<div class="entitiesListContainer">
    <div class="entitiesListMainContainer">
        <ng-container *ngIf="entities.length > 0">
            <perfect-scrollbar class="h-[calc(100vh-165px)]">
                <ng-container *ngTemplateOutlet="entitiesList; context: { entities: entities, level: 0 }"></ng-container>
            </perfect-scrollbar>
        </ng-container>
    </div>
</div>

<ng-template #entitiesList let-entities="entities" let-level="level">
    <ng-container *ngFor="let entity of entities; let i = index;">
        <ng-container *ngIf="entity.show && !entity.primary">
            <div class="entityListItemContainer" [ngClass]="{'!pl-[15px]': isCustomScreen}" stop-propagation (click)="selectEntity(entity, level)">
                <mat-icon class="entityItemIcon material-icons-outlined normalIcon" [class.activeEntity]="selectedDetails?.viewLevel?.[level]?.entityId === entity?.uid" [textContent]="supportsRecon ? 'chevron_right' : 'check_circle_outline'"></mat-icon>
                <span class="entityItemName" [class.activeEntity]="selectedDetails?.viewLevel?.[level]?.entityId === entity?.uid" [title]="entity.description || entity.displayName || entity.name" matTooltipClass="custom-tooltip" [textContent]="entity.displayName || entity.name">
                </span>
                <mat-icon *ngIf="entity?.entities.length > 0" class="entityItemIcon material-icons-outlined" title="Has sub entities">account_tree</mat-icon>
                <div class="entityChildren" *ngIf="entity.entities?.length > 0 && selectedDetails?.viewLevel?.[level]?.entityId === entity?.uid && selectedDetails?.viewLevel?.[level]?.recordId?.length > 0">
                    <ng-container *ngTemplateOutlet="entitiesList; context: { entities: entity.entities, level: level+1 }"></ng-container>
                </div>
            </div>
        </ng-container>
    </ng-container>
</ng-template>
